import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import moment from "moment";
import Paging from "../../components/Paging";
import { NavLink } from "react-router-dom";
import FormDropdown from "../../components/FormDropdown";
import ModalHelp from "../../components/ModalHelp";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

const NewDate = moment().format("YYYY-MM-DD");

class Penetapan extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataReport: [],
      dataKelas: [],
      kelas_id: "",
      user_id: "",
      user_nama: "",
      pageCount: 0,
      currentPage: 0,
      tutorial: "",
      isModalHelpShow: false,
      date: "",
      isButtonLoading: false,
      isLoading: false,
      sortName: "",
      sortOrder: "",
      startNo: 1,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDatepicker = this.handleChangeDatepicker.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.toggleModalHelp = this.toggleModalHelp.bind(this);
  }

  toggleModalHelp() {
    this.setState({ tutorial: "https://www.youtube.com/embed/1mL3jt9ot-k" });

    this.setState({ isModalHelpShow: !this.state.isModalHelpShow });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleChangeDatepicker(date, target) {
    date = moment(date, "x").format("YYYY-MM-DD");

    if (target === "mulai") {
      this.setState({
        master_tgl_jatuh_tempo: date,
      });
    } else {
      this.setState({
        master_tgl_jatuh_tempo: date,
      });
    }
  }

  handleSubmit() {
    let formData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    formData.append("created_by", localStorage.SISMART_USER_ID);
    formData.append("master_id", this.state.master_id);
    formData.append("group_id", this.state.group_id);
    formData.append(
      "master_tgl_jatuh_tempo",
      this.state.master_tgl_jatuh_tempo
    );
    formData.append("tipe_id", this.state.tipe_id);
    formData.append("master_nominal", this.state.master_nominal);

    const url =
      this.props.mode === "Tambah"
        ? "/iuran/master/add"
        : "/iuran/master/update";

    this.setState({ isButtonLoading: true });

    axios
      .post(url, formData, config)
      .then((response) => {
        const result = response.data;

        if (result.success) {
          Alert.success(result.message, {
            position: "bottom-right",
          });
          this.props.history.replace("/diskoniuran");
        } else {
          if (Array.isArray(result.message)) {
            result.message.map((item) => {
              Alert.error(item, {
                position: "bottom-right",
              });

              return true;
            });
          } else {
            Alert.error(result.message, {
              position: "bottom-right",
            });
          }

          this.setState({ isButtonLoading: false });
        }
      })
      .catch((error) => {
        console.log("ERROR", error);
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
        this.setState({ isButtonLoading: false });
      });
  }

  handlePageClick(data) {
    let selected = data.selected; // zero based index

    this.setState({ currentPage: selected }, () => {
      this.loadData();
    });
  }

  loadData() {
    this.setState({ isLoading: true, isButtonLoading: true });

    const params = qs.stringify({
      page: this.state.currentPage + 1,
      kelas_id: this.state.kelas_id,
      user_nama: this.state.user_nama,
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
    });

    axios
      .get("/iuran/datasiswa?" + params)

      .then((response) => {
        const result = response.data;

        if (result.success === true) {
          this.setState({
            dataReport: result.data.data,
            pageCount: result.data.last_page,
            isLoading: false,
            isButtonLoading: false,
            startNo: result.data.from,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
          });
        } else {
          Alert.error(result.message, {
            position: "bottom-right",
          });
          this.setState({ isLoading: false });
        }
      })

      .catch((error) => {
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
      });
  }

  loadDataKelas() {
    this.setState({ isButtonLoading: true });
    axios
      .post("/kelas")
      .then((response) => {
        return response.data.data.map((item) => ({
          key: item.kelas_id,
          value: item.kelas_nama,
        }));
      })
      .then((result) => {
        this.setState({
          dataKelas: result,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentDidMount() {
    if (
      localStorage.SISMART_USER_LEVEL !== "administrator" &&
      localStorage.SISMART_USER_LEVEL !== "keuangan"
    ) {
      this.props.history.replace("/dashboard");
    }
    this.loadData();
    this.loadDataKelas();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.location.search !== this.props.location.search ||
      prevState.user_nama !== this.state.user_nama ||
      prevState.kelas_id !== this.state.kelas_id ||
      prevState.sortName !== this.state.sortName ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.loadData();
    }
  }

  onSortChange(sortName, sortOrder) {
    this.setState({
      sortName,
      sortOrder,
    });
  }

  render() {
    const strt = this.state.startNo;
    const url = this.props.match.url;

    function indexN(cell, row, enumObject, index) {
      return <div>{index + strt}</div>;
    }

    function formatOpsi(cell, row, enumObject, index) {
      return (
        <NavLink
          exact
          to={`${url}/keuangan/${row.siswa_id}/${btoa(
            row.kelas_nama
          )}/${btoa(row.user_nama)}`}
          className="btn btn-primary btn-sm"
          style={{ margin: 3, borderRadius: 3 }}
        >
          Keuangan{" "}
        </NavLink>
      );
    }

    const options = {
      clearSearch: true,
      searchPosition: "left",
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
      onSortChange: this.onSortChange.bind(this),
    };
    return (
      <div className="col-sm-12">
        <ModalHelp
          isShow={this.state.isModalHelpShow}
          toggleModal={this.toggleModalHelp}
          handleSubmit={this.handleSubmitDeleteButton}
          modalHeaderText="Tutorial Penggunaan Fitur"
          modalBodyText={this.state.tutorial}
          modalSubmitText="Ya"
        />
        <div className="card">
          <div className="card-header">
            Tagihan Siswa
            <button
              type="button"
              title="Tutorial"
              className="btn btn-danger btn-sm"
              style={{ float: "right" }}
              onClick={() => {
                this.toggleModalHelp();
                // this.setState({ tutorial: levelName});
              }}
            >
              <i className="fa fa-question-circle" s></i>
            </button>
          </div>
          <div className="card-block">
            <div className="form-group row">
              <label
                className="col-md-1 form-control-label"
                style={{ marginTop: 3 }}
              >
                Kelas :{" "}
              </label>
              <div className="col-md-3">
                <FormDropdown
                  items={this.state.dataKelas}
                  onChange={this.handleChange}
                  style={{ borderRadius: 3 }}
                  value={this.state.kelas_id.toString()}
                  name="kelas_id"
                />
              </div>

              <label
                className="col-md-1 form-control-label"
                style={{ marginTop: 3 }}
              >
                Nama :
              </label>
              <div className="col-md-3">
                <input
                  name="user_nama"
                  type="text"
                  className="form-control"
                  placeholder="Ketikkan Nama Pengguna ..."
                  value={this.state.user_nama}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            {this.state.isLoading ? (
              "Memuat Data..."
            ) : this.state.dataReport.length === 0 ? (
              "Data tidak ditemukan..."
            ) : (
              <div>
                  <BootstrapTable
                  data={this.state.dataReport}
                  striped
                  hover
                  remote
                  options={options}
                >
                  <TableHeaderColumn
                    width="50"
                    dataField="question_id"
                    dataFormat={indexN}
                    isKey
                  >
                    No
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="user_nama"
                    dataSort
                    width="250"
                    tdStyle={{ whiteSpace: "normal" }}
                  >
                    Siswa
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="kelas_nama"
                    dataSort
                    width="200"
                  >
                    Kelas
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="siswa_nisn"
                    dataSort
                    width="200"
                  >
                    NISN
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="any"
                    width="200"
                    dataFormat={formatOpsi}
                    tdStyle={{ whiteSpace: "normal" }}
                  >
                    Action
                  </TableHeaderColumn>
                  
                </BootstrapTable>
                <hr />
                
                <Paging
                  handlePageClick={this.handlePageClick}
                  pageCount={this.state.pageCount}
                  currentPage={this.state.currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Penetapan;



// WEBPACK FOOTER //
// ./src/views/IuranSiswa/Lists.js